export const DEV_ENV_KEY = 'dev';
export const UAT_ENV_KEY = 'uat';
export const PROD_ENV_KEY = 'prod';
export const DEMO_ENV_KEY = 'demo';
export interface Params {
  uat?: boolean;
  prod?: boolean;
  dev?: boolean;
  demo?: boolean;
}
export default (params: Params) => {
  const currentEnv = window.REACT_APP_ENV || import.meta.env.REACT_APP_ENV;
  if (currentEnv === DEV_ENV_KEY && params?.dev === true) {
    return true;
  }
  if (currentEnv === UAT_ENV_KEY && params?.uat === true) {
    return true;
  }
  if (currentEnv === PROD_ENV_KEY && params?.prod === true) {
    return true;
  }
  if (currentEnv === DEMO_ENV_KEY && params?.demo === true) {
    return true;
  }
  return false;
};
